import { AppSession, createDefaultSession } from "./defaultSession";

const STORAGE_KEY = "blazebite_session";

function getNestedValue(obj: any, path: string): any {
  return path.split(".").reduce((acc, key) => acc?.[key], obj);
}

function setNestedValue(obj: any, path: string, value: any): any {
  const clone = JSON.parse(JSON.stringify(obj));
  const keys = path.split(".");
  let current = clone;
  for (let i = 0; i < keys.length - 1; i++) {
    if (current[keys[i]] === undefined || current[keys[i]] === null) {
      current[keys[i]] = {};
    }
    current = current[keys[i]];
  }
  const lastKey = keys[keys.length - 1];
  if (
    typeof value === "object" &&
    value !== null &&
    !Array.isArray(value) &&
    typeof current[lastKey] === "object" &&
    current[lastKey] !== null &&
    !Array.isArray(current[lastKey])
  ) {
    current[lastKey] = { ...current[lastKey], ...value };
  } else {
    current[lastKey] = value;
  }
  return clone;
}

export function getSession(): AppSession {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return createDefaultSession();
    const parsed = JSON.parse(raw);
    if (!isSessionValid(parsed)) return createDefaultSession();
    return parsed as AppSession;
  } catch {
    return createDefaultSession();
  }
}

export function setSession(session: AppSession, source?: string): boolean {
  try {
    // Centralized cartId diff logging
    const prevRaw = localStorage.getItem(STORAGE_KEY);
    const prevCartId = prevRaw ? (JSON.parse(prevRaw)?.order?.cartId ?? "") : "";
    const nextCartId = session?.order?.cartId ?? "";
    if (prevCartId !== nextCartId) {
      console.warn(
        `[DEBUG cartId] CHANGED | source=${source ?? "unknown"} | "${prevCartId}" → "${nextCartId}" | ${new Date().toISOString()}`,
        new Error().stack
      );
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    return true;
  } catch {
    return false;
  }
}

export function updateSession(path: string, value: any): AppSession {
  const current = getSession();
  const updated = setNestedValue(current, path, value);
  setSession(updated);
  return updated;
}

export function clearSession(): AppSession {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  return createDefaultSession();
}

export function getSessionField(path: string): any {
  const session = getSession();
  return getNestedValue(session, path);
}

export function isSessionValid(obj?: any): boolean {
  const target = obj ?? getSession();
  return (
    typeof target === "object" &&
    target !== null &&
    "order" in target &&
    "customer" in target &&
    "cartItemsLength" in target
  );
}
